import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { FieldInput, FieldDropdown } from '../inputs'

const PrimaryFieldsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
`

const ContainerInnerDiv = styled.div`
  display: block;
  padding: 24px;
`
const PrimaryFieldsGridOne = styled.div`
  grid-column-start: 1;
`

const PrimaryFieldsGridTwo = styled.div`
  grid-column-start: 2;
  margin-left: 12px;
`

const AdjustedFieldInput = styled(FieldInput)`
  height: 48px;
`

const AdjustedFieldDropdown = styled(FieldDropdown)`
  height: 48px;
`

const RentDetails = ({ values, setFieldValue }) => {
  const { t } = useTranslation()
  return (
    <ContainerInnerDiv>
      <PrimaryFieldsContainer>
        <PrimaryFieldsGridOne>
          <AdjustedFieldInput
            id="price"
            name="price"
            prefix="$"
            value={values?.price}
            autoComplete="off"
            onChange={e => {
              const value = parseFloat(e.target.value)
              const isInvalid = isNaN(value)
              setFieldValue('price', isInvalid ? '' : value)
            }}
            placeholder={t('l.contract_edit.lease_terms.rent_price.placeholder', 'Rent Price')}
          />
        </PrimaryFieldsGridOne>
        <PrimaryFieldsGridTwo>
          <AdjustedFieldDropdown
            id="price_frequency"
            name="price_frequency"
            placeholder={t(
              'l.contract_edit.lease_terms.payment_frequency.placeholder',
              'Payment Frequency'
            )}
            onChange={e => setFieldValue('price_frequency', e)}
            options={[
              {
                value: 'daily',
                label: t('common.frequency_daily', 'Daily')
              },
              {
                value: 'weekly',
                label: t('common.frequency_weekly', 'Weekly')
              },
              {
                value: 'monthly',
                label: t('common.frequency_monthly', 'Monthly')
              },
              {
                value: 'one_time',
                label: t('common.frequency_one_time', 'One-time')
              }
            ]}
          />
        </PrimaryFieldsGridTwo>
      </PrimaryFieldsContainer>
    </ContainerInnerDiv>
  )
}

export default RentDetails
